export default {
  tiles: [
    {
      id: 1,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/nerd-carousel/final/desktop/Carousel-Image-Desktop-01-v2.jpg',
      imageAlt: '',
      nerdName: 'Luis',
      nerdTitle: 'Product Analytics Nerd',
      darkBackground: true,
      nerdDescription:
        "Having joined as a remote Nerd, I wasn't sure what it would be like to work with teams I'd never met in person. But through fun and interactive Slack channels, thematic happy hours, and inclusive team meetings, I've never felt out of place. We all belong here.",
    },
    {
      id: 2,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/nerd-carousel/final/desktop/Carousel-Image-Desktop-02-v2.jpg',
      imageAlt: '',
      nerdName: 'Rachel',
      nerdTitle: 'People Operations Nerd',
      darkBackground: true,
      nerdDescription:
        "I'm thankful to work at a company that supports me as an employee and as a parent. From flexible scheduling so that I can pick up my daughter from school to designated company-wide Mental Health Days, to generous parental leave, NerdWallet allows me to bring my whole self.",
    },
    {
      id: 3,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/nerd-carousel/final/desktop/Carousel-Image-Desktop-03-v2.jpg',
      imageAlt: '',
      nerdName: 'Hass',
      nerdTitle: 'Product Design Nerd',
      darkBackground: true,
      nerdDescription:
        'Being at NerdWallet creates so many opportunities for cross-functional collaboration! Nerds are encouraged to reach out well beyond their primary teams to tackle challenges in delivering nerdy expertise to our appreciative users.',
    },
    {
      id: 4,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/nerd-carousel/final/desktop/Carousel-Image-Desktop-04-v2.jpg',
      imageAlt: '',
      nerdName: 'Kimra',
      nerdTitle: 'User Experience Nerd',
      darkBackground: true,
      nerdDescription:
        "A lot of companies say they're consumer-first, but I've never had a workplace strive to put real people front and center quite like NerdWallet. It's clear Nerds care deeply about the humans we serve.",
    },
    {
      id: 5,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/nerd-carousel/final/desktop/Carousel-Image-Desktop-05-v2.jpg',
      imageAlt: '',
      nerdName: 'Jon',
      nerdTitle: 'Brand Studio Nerd',
      darkBackground: true,
      nerdDescription:
        "Curiosity is a powerful thing, and it's what excites me about coming to work every day. NerdWallet has built a culture of openness and willingness to challenge our own assumptions and status quo — giving everyone more opportunity to be creative, collaborative, and impactful.",
    },
    {
      id: 6,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/nerd-carousel/final/desktop/Carousel-Image-Desktop-06-v2.jpg',
      imageAlt: '',
      nerdName: 'Gerard',
      nerdTitle: 'Performance Marketing Nerd',
      darkBackground: true,
      nerdDescription:
        "NerdWallet has provided me the freedom to be my full self in the workplace, and that commitment to its employees' full self has attracted a diverse array of hard-working, talented coworkers.",
    },
    {
      id: 7,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/nerd-carousel/final/desktop/Carousel-Image-Desktop-07-v2.jpg',
      imageAlt: '',
      nerdName: 'Sharadh',
      nerdTitle: 'Engineering Nerd',
      darkBackground: true,
      nerdDescription:
        "Every day I've worked here, I've had the privilege of engaging with smart and just plain nice people. Everyone is committed to learning and growing, and is gracious with time and support.",
    },
    {
      id: 8,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/nerd-carousel/final/desktop/Carousel-Image-Desktop-08-v2.jpg',
      imageAlt: '',
      nerdName: 'Yuri',
      nerdTitle: 'Product Management Nerd',
      darkBackground: true,
      nerdDescription:
        "You're given a lot of ownership from the beginning. It may be frightening at the start, but you are surrounded with brilliant colleagues who are rooting for your success. You are able to flex your strengths here and as a team, make an impact for NerdWallet’s customers.",
    },
  ],
};
